import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import POMasterListing from "../../../components/SidebarMenuComponents/OAComponent/POMasterListing";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function POMasterListingPage() {
    const location = useLocation();
    const poMaster = location.state;
    return (
        <Page title="  PO Master Listing | tiketic" >
           
            <StickyHeader title="PO Master Listing" />

            <ContentStyle>
                <POMasterListing poMaster={poMaster } />
            </ContentStyle>
        </Page>
    );
}

